module.exports = __webpack_public_path__ + "img/109.7ddfa27e.png";